module.exports = __webpack_public_path__ + "media/images/logo@2x-17bee3ef.gif";